<cam-badge [value]="this.label() | translate" [type]="this.type()"></cam-badge>
